// import '../scss/app.scss'
// import '../pug/index.pug'
import '../pug/product.pug'
import '../pug/services.pug'

// Babel Polyfill
// import 'core-js/stable'
// import 'regenerator-runtime/runtime'

// const ready = function(callbackFunc) {
//   if (document.readyState !== 'loading') {
//     // Document is already ready, call the callback directly
//     callbackFunc();
//   } else if (document.addEventListener) {
//     // All modern browsers to register DOMContentLoaded
//     document.addEventListener('DOMContentLoaded', callbackFunc);
//   } else {
//     // Old IE browsers
//     document.attachEvent('onreadystatechange', function() {
//       if (document.readyState === 'complete') {
//         callbackFunc();
//       }
//     });
//   }
// }



// const is_ie11 = !!window.MSInputMethodContext && !!document.documentMode;
// const isIE = /Edge|MSIE|Trident/.test(window.navigator.userAgent);

// if (isIE) {
//   import(
//     `clip-path`
//     /* webpackChunkName: "___ie_clip" */
//   )
//   .then((module) => {
//     console.log('ClipPath', module);
//     module.ClipPath('.b-main-quotes', '0 0, 100% 100px, 100% 100%, 0 100%');
//   })
// }

import './public-path';
import svg from "./svg";
svg();

import burger from "./burger";
burger();

const checkMobile = function () {
  return (/Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) );
}
const isMobile = checkMobile()
window.isMobile = isMobile

import "./header-stick";
import "./pop";


// for main only
import "./quotes";
import { initArrows } from "./1-2-3"; // influenced on aside
initArrows()


if (isMobile) {
  import(
    `./mobileTabsToggler`
    /* webpackChunkName: "inject_mobileTabsToggler" */
  )
  .then((module) => {
    module.initTabs()
  })
} else {
  // import(
  //   `./tabsToggler`
  //   /* webpackChunkName: "inject_tabsToggler" */
  // )
  // .then((tabsToggler) => {
  //   tabsToggler.initTabs()
  // })
  // https://2ality.com/2017/01/import-operator.html
  Promise.all([
    import(
      `./tabsToggler`
      /* webpackChunkName: "inject_tabsToggler" */
    ),
    import(
      `./aside`
      /* webpackChunkName: "inject_aside" */
    ),
  ])
  .then(([tabsToggler, aside]) => {
    tabsToggler.initTabs()
    aside.initAside()
  })
}

let isCustomSelect = document.querySelector('.b-form__select-wrapper')
if (isCustomSelect && !isMobile) {
  import(
    `./customSelect`
    /* webpackChunkName: "inject_customSelect" */
  )
  .then((module) => {
    module.initCustomSelect()
    window.initCustomSelect = module.initCustomSelect // proxy to formProcessor
  })
}

import { formProcessor } from "./form";
let _form = document.getElementById("_Form");
formProcessor(_form);

let _formSubscribe = document.getElementById("_FormSubscribe");
if (_formSubscribe) {
  formProcessor(_formSubscribe);
}


// // import BackgroundCheck from 'imports-loader?additionalCode=var%20define%20=%20false;!./libs/background-check'
// BackgroundCheck.init({
//   targets: '.b-aside',
//   // images: _GD.images, 
//   threshold: 100,
//   minComplexity: 60,
// //            minOverlap: 1, 
//   classes:  {
//       dark: '_white',
//       light: '_black',
//       complex: '_gray' 
//   }
//           //  ,debug: true 
// });   